import { useEffect, useRef } from 'react';
import { Outlet } from 'react-router-dom';
import { useCheckout } from '../hooks/useCheckout.js';
import { useBasket } from '../context/BasketContext.jsx';
import { useStoreConfig } from '../context/StoreConfigContext.jsx';
import { useStoreUI } from '../context/StoreUIContext.jsx';
import { useToast } from '../context/ToastContext.jsx';
import { handoffNotice } from '../lib/handoffNotice.js';
import { Announcements } from './Announcements.jsx';
import { BasketSidebar } from './BasketSidebar.jsx';
import { BottomNav } from './BottomNav.jsx';
import { CategoryNav } from './CategoryNav.jsx';
import { CustomerGoal } from './CustomerGoal.jsx';
import { Footer } from './Footer.jsx';
import { LoginModal } from './LoginModal.jsx';
import { GiftModal } from './GiftModal.jsx';
import { PerksModal } from './PerksModal.jsx';
import { PolicyCards } from './PolicyCards.jsx';
import { SidebarStatus } from './SidebarStatus.jsx';
import { SkyParticles } from './SkyParticles.jsx';
import { Topbar } from './Topbar.jsx';

export function StoreLayout() {
  const { start, isLaunching } = useCheckout();
  const { handoff, clearHandoff, rankState, isReady } = useBasket();
  const { reload } = useStoreConfig();
  const { openBasket } = useStoreUI();
  const { showToast } = useToast();
  const lastRank = useRef('logged_out');

  useEffect(() => { if (isReady) reload(); }, [isReady, rankState, reload]);

  useEffect(() => {
    if (!isReady || rankState === lastRank.current) return;
    lastRank.current = rankState;
    if (rankState === 'immortal') showToast('Ranks are hidden: Immortal is the highest rank.', 6000, 'info');
    else if (['vip', 'mvp', 'lord', 'heroic'].includes(rankState))
      showToast('Ranks are hidden; your next upgrade is in Rank Upgrades.', 6000, 'info');
    else if (rankState === 'unavailable')
      showToast('Rank eligibility is temporarily unavailable. Other packages remain available.', 6000, 'info');
  }, [isReady, rankState, showToast]);

  useEffect(() => {
    if (!handoff) return;
    const notice = handoffNotice(handoff);
    if (notice.openBasket) openBasket();
    showToast(notice.message, notice.duration, notice.type);
    clearHandoff();
  }, [handoff, clearHandoff, openBasket, showToast]);

  return (
    <>
      <SkyParticles />

      <div className="container">
        <Topbar />
        <Announcements />

        <div className="body">
          <div className="left-column">
            <SidebarStatus />
            <CategoryNav />
            <CustomerGoal />
            <PolicyCards />
          </div>

          <Outlet />
        </div>
      </div>

      <Footer />

      <LoginModal />
      <GiftModal />
      <BasketSidebar onCheckout={start} isCheckoutLaunching={isLaunching} />
      <PerksModal />
      <BottomNav />
    </>
  );
}
